import { render, staticRenderFns } from "./SSRApp.vue?vue&type=template&id=15b7bc46"
import script from "./SSRApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SSRApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SSRApp.vue?vue&type=style&index=0&id=15b7bc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports